import { render, staticRenderFns } from "./zixunIndex.vue?vue&type=template&id=a0657f4a&scoped=true&"
import script from "./zixunIndex.vue?vue&type=script&lang=js&"
export * from "./zixunIndex.vue?vue&type=script&lang=js&"
import style0 from "./zixunIndex.vue?vue&type=style&index=0&id=a0657f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0657f4a",
  null
  
)

export default component.exports